
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"1.75 5.08 16.5 9.68"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.5 5.833v8.182h15L10 9.925 2.5 5.832z","fill":"#0C9648"}}),_c('path',{attrs:{"d":"M17.5 14.015V5.834L10 9.924l7.5 4.091z","fill":"#0C9648"}}),_c('path',{attrs:{"d":"M2.5 5.833v8.182h15m-15-8.181l7.5 4.09m-7.5-4.09h15m0 8.181V5.834m0 8.181L10 9.925m7.5-4.092L10 9.925","stroke":"#0C9648","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    